export default String.raw`
{% if config.Complaints.ComplaintsEnabled or config.Complaints.ReturnsEnabled -%}
	{% assign complaintsOrReturnsEnabled = true -%}
{% endif -%}

<div class="products-table-header-js">
	<thead>
		<tr class="products-table-header-container-js">
			<td class="number-column-js"></td>
			<th>{{translations.Product}}</th>
		{% if page.PageId == config.DefinedPages.Order.Id -%}
			{% assign attributes = config.Orders.AttributesCart.Position -%}
			{% assign positionAttrSize = attributes | Size -%}
			{% assign nullAttributes = '' -%}
		{% elseif page.PageId == config.DefinedPages.CustomerProfile.Id and order.EditingAllowed -%}
			{% assign attributes = config.Orders.AttributesEdit.Position -%}
			{% assign positionAttrSize = attributes | Size -%}
			{% assign allProducts = order.Products | Size -%}
			{% assign nullAttributes = '' -%}
			{% for positionAttr in attributes -%}
				{% assign intId = positionAttr.Id | ToInt -%}
				{% assign nullProducts = 0 -%}
				{% for tableProduct in order.Products -%}
					{% if positionAttr.Editable == false and tableProduct.Attributes[intId].Value == null -%}
						{% assign nullProducts = nullProducts | Plus:1 -%}
					{% endif -%}
				{% endfor -%}
				{% if nullProducts == allProducts -%}
					{% assign positionAttrSize = positionAttrSize | Minus:1 -%}
					{% assign idString = positionAttr.Id | ToString -%}
					{% assign nullAttributes = nullAttributes | Append:idString | Append:'|' -%}
				{% endif -%}
			{% endfor -%}
			{% if nullAttributes != '' -%}
				{% assign nullAttributes = nullAttributes | Split:'|' -%}
			{% endif -%}
		{% elseif page.PageId == config.DefinedPages.CustomerProfile.Id and order.EditingAllowed == false -%}
			{% unless page.QueryString contains 'tab=inquiry-details' -%}
				{% assign history = true -%}
				{% assign names = '' -%}
				{% assign ids = '' -%}
				{% for tableProduct in order.Products -%}
					{% for positionAttr in tableProduct.Attributes -%}
						{% assign idString = positionAttr.Id | ToString -%}
						{% if ids == '' -%}
							{% assign names = names | Append:positionAttr.Name -%}
							{% assign ids = ids | Append:idString -%}
						{% else -%}
							{% assign inArr = false -%}
							{% assign ids = ids | Split:'|' -%}
							{% for id in ids -%}
								{% if id == idString -%}
									{% assign inArr = true -%}
									{% break -%}
								{% endif -%}
							{% endfor -%}
							{% assign ids = ids | Join:'|' -%}
							{% if inArr == false -%}
								{% assign names = names | Append:'|' | Append:positionAttr.Name -%}
								{% assign ids = ids | Append:'|' | Append:idString -%}
							{% endif -%}
						{% endif -%}
					{% endfor -%}
				{% endfor -%}
				{% if ids != '' -%}
					{% assign names = names | Split:'|' -%}
					{% assign attributes = ids | Split:'|' -%}
					{% assign positionAttrSize = attributes | Size -%}
					{% assign allProducts = order.Products | Size -%}
					{% assign nullAttributes = '' -%}
					{% for positionAttr in attributes -%}
						{% assign intId = positionAttr | ToInt -%}
						{% assign nullProducts = 0 -%}
						{% for tableProduct in order.Products -%}
							{% if tableProduct.Attributes[intId].Value == null or tableProduct.Attributes[intId].Value == '' -%}
								{% assign nullProducts = nullProducts | Plus:1 -%}
							{% endif -%}
						{% endfor -%}
						{% if nullProducts == allProducts -%}
							{% assign positionAttrSize = positionAttrSize | Minus:1 -%}
							{% assign idString = positionAttr | ToString -%}
							{% assign nullAttributes = nullAttributes | Append:'|' | Append:idString -%}
						{% endif -%}
					{% endfor -%}
					{% if nullAttributes != '' -%}
						{% assign nullAttributes = nullAttributes | Split:'|' -%}
					{% endif -%}
				{% endif -%}
			{% endunless -%}
		{% endif -%}
			
		{% unless page.QueryString contains 'tab=inquiry-details' -%}
		<th class="price-like-column-js prices-view-js">
			{{translations.Price}}
			{% if config.ENTERPRISE or cart.SubtotalPrices -%}
				{{translations.Netto | Downcase }}
			{% else -%}
				{{translations.Brutto | Downcase }}
			{% endif -%}
		</th>
		{% endunless -%}
			
		{% if config.ENTERPRISE -%}
			{% unless page.QueryString contains 'tab=inquiry-details' -%}
			<th class="price-like-column-js prices-view-js">
				{{translations.Price}} {{translations.Brutto | Downcase}}
			</th>
			{% endunless -%}
		{% endif -%}

		{% unless customer.Cart.Inquiry -%}
			{% unless page.QueryString contains 'tab=inquiry-details' -%}
				<th class="percent-column-js prices-view-js">
					{{translations.Vat}}
				</th>
				{% if page.QueryString contains 'tab=offer-details' -%}
				    {% assign DepositValue = order.DepositValue -%}
				{% else -%}
					{% assign DepositValue = order.TotalDepositValue -%}
				{% endif -%}
				{% if DepositValue > 0 -%}
					<th scope="col">
						{{ translations.Com_Deposit }}
					</th>
				{% endif -%}
			{% endunless -%}
		{% endunless -%}

			<th class="amount-stepper-column-js prices-view-js">
				{{translations.Quantity}}
			</th>

		{% unless customer.Cart.Inquiry -%}
			{% if isDiscount -%}
			<th class="percent-column-js prices-view-js">
				{% unless page.QueryString contains 'tab=inquiry-details' -%}
					{{translations.Discount}}
				{% endunless -%}
			</th>
			{% endif -%}
		{% endunless -%}
			
		{% unless page.QueryString contains 'tab=inquiry-details' -%}
		<th class="price-like-column-js prices-view-js">
			{{translations.Value}}
			{% if config.ENTERPRISE or cart.SubtotalPrices -%}
				{{translations.Netto | Downcase }}
			{% else -%}
				{{translations.Brutto | Downcase }}
			{% endif -%}
		</th>
		{% endunless -%}
			
		{% if config.ENTERPRISE -%}
			
			{% unless page.QueryString contains 'tab=inquiry-details' -%}
			<th class="price-like-column-js prices-view-js">
				{{translations.Value}} {{translations.Brutto | Downcase}}
			</th>
			{% endunless -%}

		{% endif -%}
		{% unless page.QueryString contains 'tab=inquiry-details' -%}
		<th class="currency-column-js prices-view-js">
			{{translations.Currency}}
		</th>
		{% endunless -%}

		{% if page.PageId == config.DefinedPages.CustomerProfile.Id -%}
			<td class="options">
				{% unless product.Description == "" -%}
				{% endunless -%}
			</td>
		{% else -%}
			<td class="options">
				{% unless product.Description == "" and product.Weight <= 0 and product.Status.Text == null -%}
				{% endunless -%}
			</td>
		{% endif -%}
			<th class="options options-column-js">
				<button aria-label="{{translations.Options}}" class="pure-button open-dropdown-js">
					<svg width="24" height="24" style="transform: rotate(90deg);">
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#ellipsis-h-{{settings.iconStyle}}"></use>
					</svg>
				</button>
				<div class="dropdown dropdown-js hidden-js">
					<button class="pure-button roll-out-js">{{translations.RollOutEverything}}</button>
					<button class="pure-button roll-up-js">{{translations.RollUpEverything}}</button>
				</div>
			</th>
		{% if order.OrderStep == 'Start' or order.EditingAllowed -%}
			<th class="remove-product-js"></th>
		{% endif -%}
		{% if order.EditingAllowed -%}
			<th class="options options-column-js"></th>
		{% elseif order.Status == 3 and complaintsOrReturnsEnabled -%}
			<th class="open-complaint-form-container-js"></th>
		{% endif -%}
		</tr>
	</thead>
</div>
`